// extracted by mini-css-extract-plugin
module.exports = {"root":"status-chip_root__VjNBm"};